import I18n from 'components/I18n'
import Text from 'components/Text'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color, screenWidth } from 'utils'

import { languagePrefixes, languages } from '../../providers/ConnectedIntl/languages'
import ExchangeLogo from './ExchangeLogo'
import LanguageItem from './LanguageItem'

const Wrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 1rem;
  background: ${color('dark900')};
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;

  @media only screen and (min-width: ${screenWidth('sm')}) {
    width: 50%;
    height: 50%;
  }
`
const EscapeContainer = styled.div`
  position: absolute;
  top: 1.3rem;
  right: 4rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  & > :not(:last-child) {
    margin-right: 0.5rem;
  }

  @media only screen and (max-width: ${screenWidth('sm')}) {
    display: none;
  }
`
const EscapeKey = styled.div`
  padding: 0.25rem 0.75rem;
  border: 1px solid ${color('white')};
  border-radius: 5px;
`

const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  height: 100px;
  padding: 1rem 0;
`
const LanguageRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  height: calc(100% - 100px);
`

const LanguageSelection = () => (
  <Wrapper>
    <EscapeContainer>
      <Text color='white' size='md'>
        <I18n data={messages.modal_hit} />
      </Text>
      <EscapeKey>
        <Text color='white' size='md' textTransform='uppercase'>
          Esc
        </Text>
      </EscapeKey>
      <Text color='white' size='md'>
        <I18n data={messages.modal_close} />
      </Text>
    </EscapeContainer>
    <Container>
      <TitleRow>
        <ExchangeLogo />
      </TitleRow>
      <LanguageRow>
        {languagePrefixes.map((languagePrefix) => (
          <LanguageItem
            display={languages[languagePrefix]}
            key={languagePrefix}
            prefix={languagePrefix}
          />
        ))}
      </LanguageRow>
    </Container>
  </Wrapper>
)

export default LanguageSelection
